import styled from 'styled-components';

export default styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: auto;
  ${props => props.defaultFont ? 'font-family:'+props.defaultFont+';' : ''}
  ${ props => props.thisStyles }
`;
